import {AutorunComponent} from '@myshared/autorun.component';
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Model} from '../../app.model';
import {Order} from '../order.model';
import {OrderService} from '../order.service';
import {action, observable} from '@myshared/mobx-connector';
import {filterText} from '@myshared/utils';
import {runInAction} from 'mobx';
import {OrderState} from "../../buy/buy.model";

@Component({
    selector: 'app-order-orders',
    templateUrl: './order-orders.component.html',
    standalone: false
})
export class OrderOrdersComponent extends AutorunComponent implements OnInit, OnChanges {

    @Input() state: OrderState;

    public orders: Order[];
    private offset = 0;
    @observable private filter$: string;

    constructor(
        private m: Model,
        private orderService: OrderService
    ) {
        super();
    }

    ngOnInit(): void {
        runInAction(() => {
            this.filter$ = '';
            this.offset = 0;
        });

        this.loadOrders();

        this.autorun(() => {
            this.orders = filterText(this.m.order.orders, this.filter$);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['state'] && !changes['state'].firstChange) {
            this.offset = 0;
            this.loadOrders();
        }
    }

    loadOrders() {
        this.orderService.refresh(true, 'sale_orders', this.state, 0);
    }

    onRefresh() {
        this.orderService.refresh(true, 'sale_orders', this.state, 0);
    }

    get needsPagination(): boolean {
        return this.orders && this.orders.length >= 20 && this.orders.length % 20 == 0 && this.m.order.loadMore;
    }

    @action
    doFilter(filter: string) {
        this.filter$ = filter;
    }

    nextPage() {
        this.offset = this.offset + 20;
        this.orderService.refresh(true, 'sale_orders', this.state, this.offset);
    }

    showExpired(value: boolean) {
        this.orderService.refresh(true, 'sale_orders', this.state, this.offset, value);
    }
}
